<template>
	<div :class="{ hidden: hidden, stacked: slotStacked }" class="pagination-container">

        <div v-if="slotPosition == 'before'" class="slot-wrapper" :class="{'slot-before': slotStacked}">
		    <slot></slot>
        </div>

        <el-pagination
			:background="background"
			:current-page.sync="currentPage"
			:page-size.sync="pageSize"
			:layout="layout"
			:page-sizes="pageSizes"
			:total="total"
            :pager-count="pagerCount"
			v-bind="$attrs"
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
		/>

        <div v-if="slotPosition == 'after'" class="slot-wrapper" :class="{'slot-after': slotStacked}">
		    <slot></slot>
        </div>

	</div>
</template>

<script>
	import { scrollTo } from "@shared/directives/scrollTo"

	export default {
		name: "Pagination",
		props: {
			total: {
				required: true,
			},
			page: {
				type: Number,
				default: 1,
			},
			limit: {
				default: 50,
			},
			pageSizes: {
				type: Array,
				default() {
					return [10, 20, 30, 50]
				},
			},
			layout: {
				type: String,
				default: "total, sizes, prev, pager, next, jumper",
			},
			background: {
				type: Boolean,
				default: true,
			},
			autoScroll: {
				type: Boolean,
				default: true,
			},
			hidden: {
				type: Boolean,
				default: false,
			},
			separateChange: {
				type: Boolean,
				required: false,
				default: false,
			},
            slotStacked: {
                type: Boolean,
                required: false,
                default: false,
            },
            slotPosition: {
                type: String,
                required: false,
                default: 'after'
            },
            pagerCount: {
                type: Number,
                required: false,
                default: 7
            }
		},
		computed: {
			currentPage: {
				get() {
					return this.page
				},
				set(val) {
					this.$emit("update:page", val)
				},
			},
			pageSize: {
				get() {
					return parseInt(this.limit)
				},
				set(val) {
					this.$emit("update:limit", val)
				},
			},
		},
		methods: {
			handleSizeChange(val) {
				if (this.separateChange) {
					this.$emit("sizeChange", { page: this.currentPage, limit: val, loading: true })
					if (this.autoScroll) {
						scrollTo(0, 800)
					}
				} else {
					this.$emit("pagination", { page: this.currentPage, limit: val, loading: true })
					if (this.autoScroll) {
						scrollTo(0, 800)
					}
				}
			},
			handleCurrentChange(val) {
				this.$emit("pagination", { page: val, limit: this.pageSize, loading: true })
				if (this.autoScroll) {
					scrollTo(0, 800)
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.pagination-container {
		background: #fff;
		padding: 32px 16px;
		display: flex;

        &.stacked {
            display: block;
        }
	}
	.pagination-container.hidden {
		display: none;
	}
    .slot-wrapper {
        display: flex;
        justify-content: space-between;

        &.slot-before {
            margin-bottom: 10px;
        }

        &.slot-after {
            margin-top: 10px;
        }
    }
</style>
